import { formDataRequest, postRequest, getRequest } from "../libs/AxiosService.util";

export async function serviceEmployeeBGVList(params) {
  return await postRequest("employee/verification/list", params);
}
export async function serviceEmployeeBGVListOld(params) {
  return await postRequest("employee/verification/list/prior", params);
}
export async function serviceEmployeeBGVCreate(params) {
  return await postRequest("employee/verification/create", params);
}

export async function serviceEmployeeBGVUpdate(params) {
  return await postRequest("employee/verification/update", params);
}

export async function serviceEmployeeBGVDetail(params) {
  return await postRequest("employee/verification/details", params);
}

export async function serviceEmloyeeBGVTable(params) {
  return await postRequest("employee/verification/table", params);
}
export async function serviceEmloyeeBGVTablePrior(params) {
  return await postRequest("employee/verification/table/prior", params);
}
export async function serviceBGVDownload(params) {
  return await postRequest("employee/verification/export/report", params);
}
export async function serviceBGVDownloadPrior(params) {
  return await postRequest("employee/verification/export/report/prior", params);
}
export async function serviceBGVDownloadAll(params) {
  return await postRequest("employee/verification/export/report/all", params);
}
export async function serviceBGVDownloadAllPrior(params) {
  return await postRequest("employee/verification/export/report/prior/all", params);
}
export async function serviceBgvStatusFilter(params){
  return await postRequest("employee/verification/filter/status", params)
}
export async function serviceBgvEmployeeDocuments(params){
  return await postRequest("employee/verification/employee/documents", params)
}
export async function serviceBgvUploadDocList(params){
    return await postRequest('employee/verification/documents/list',params)
}
export async function serviceBgvUploadDocFile(params){
    return await formDataRequest('files/upload',params, {
  folder: "onboarding_samples",
})
}
export async function serviceBgvEmployeeSubmitDocuments(params){
  return await postRequest("employee/verification/submit/documents", params)
}
export async function serviceBgvEmployeeDocumentDetails(params){
  return await postRequest("employee/verification/employee/documents", params)
}
export async function serviceBgvEmployeeTimeline(params){
  return await postRequest("employee/verification/timeline", params)
}
export async function serviceBgvEmployeeRehire(params){
  return await postRequest("employee/verification/mark/rehired", params)
}